import { request } from "../utils/request.js"

export const commodityOutputOrder_exportForManage = (pojo, args) => request({
    url: 'commodityOutputOrder/exportForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const commodityOutputOrder_findPageForManage = (pojo, args) => request({
    url: 'commodityOutputOrder/findPageForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const commodityOutputOrder_findPageListForManage = (pojo, args) => request({
    url: 'commodityOutputOrder/findPageListForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const commodityOutputOrder_findPageForDeliveryManage = (pojo, args) => request({
    url: 'commodityOutputOrder/findPageForDeliveryManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const commodityOutputOrder_findPageListForDeliveryManage = (pojo, args) => request({
    url: 'commodityOutputOrder/findPageListForDeliveryManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})


export const commodityOutputOrder_findPageForCurrentUserDelivery = (pojo, args) => request({
    url: 'commodityOutputOrder/findPageForCurrentUserDelivery',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const commodityOutputOrder_findPageListForCurrentUserDelivery = (pojo, args) => request({
    url: 'commodityOutputOrder/findPageListForCurrentUserDelivery',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const commodityOutputOrder_findPageForCurrentUser = (pojo, args) => request({
    url: 'commodityOutputOrder/findPageForCurrentUser',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const commodityOutputOrder_findPageListForCurrentUser = (pojo, args) => request({
    url: 'commodityOutputOrder/findPageListForCurrentUser',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const commodityOutputOrder_saveIntoDraft = (pojo, args) => request({
    url: 'commodityOutputOrder/saveIntoDraft',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const commodityOutputOrder_saveIntoDraftAndSubmit = (pojo, args) => request({
    url: 'commodityOutputOrder/saveIntoDraftAndSubmit',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const commodityOutputOrder_update = (pojo, args) => request({
    url: 'commodityOutputOrder/update',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const commodityOutputOrder_updateAndSubmit = (pojo, args) => request({
    url: 'commodityOutputOrder/updateAndSubmit',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const commodityOutputOrder_submitById = (id, args) => request({
    url: 'commodityOutputOrder/submitById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const commodityOutputOrder_deleteById = (id, args) => request({
    url: 'commodityOutputOrder/deleteById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const commodityOutputOrder_approval = (pojo, args) => request({
    url: 'commodityOutputOrder/approval',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const commodityOutputOrder_distributeDelivery = (pojo, args) => request({
    url: 'commodityOutputOrder/distributeDelivery',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const commodityOutputOrder_startDelivery = (id, args) => request({
    url: 'commodityOutputOrder/startDelivery',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const commodityOutputOrder_completeDelivery = (pojo,args) => request({
    url: 'commodityOutputOrder/completeDelivery',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const commodityOutputOrder_confirmDelivery = (id, args) => request({
    url: 'commodityOutputOrder/confirmDelivery',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const commodityOutputOrder_findById = (id, args) => request({
    url: 'commodityOutputOrder/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const commodityOutputOrder_findVoById = (id, args) => request({
    url: 'commodityOutputOrder/findVoById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const commodityOutputOrder_generatePrintPdf = (pojo, args) => request({
    url: 'commodityOutputOrder/generatePrintPdf',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})


// WEBPACK FOOTER //
// ./src/api/commodityOutputOrder.js